module.exports = __webpack_public_path__ + "img/17000sbjj2.85cf77ef.png";